import { render, staticRenderFns } from "./monthCarFeeDetailV3.vue?vue&type=template&id=2486df6a&"
import script from "./monthCarFeeDetailV3.vue?vue&type=script&lang=js&"
export * from "./monthCarFeeDetailV3.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports